enum ApiErrorType {
  CONNECTION = 'Connection',
  BAD_REQUEST = 'Bad Request',
  UNAUTHORIZED = 'Unauthorized',
  FORBIDDEN = 'Forbidden',
  NOT_FOUND = 'Not Found',
  CONFLICT = 'Conflict',
  DATA_VALIDATION_FAILED = 'Data Validation Failed',
  INTERNAL_SERVER_ERROR = 'Internal Server Error',
  CUSTOM = 'Custom',
  UNKNOWN = 'Unknown'
}

export default ApiErrorType
